/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/8/7
 * Time: 9:55
 * Desc: 基础设置-其他-虚拟店长佣金阈值
 */

import { Component, Vue } from 'vue-property-decorator';
import type { ElForm } from 'element-ui/types/form';
import { quillEditor } from 'vue-quill-editor';
import { IPSService } from '@/services/ipsServices';
import { EmpResConfig } from '@/services/empService/config';
import editorOptionConfig from '@/library/utils/editerOptionConfig'; // 富文本编辑器全局配置
import Tax from '@/views/components/vmCommissionLimit/tax.vue';

interface vmCommission {
  maxCommission?: number;
  taxesList?: Array<taxesItem>;
  vGuiderNote?: string;
  taxesContent?: taxesContent;
  serviceRate?: number;
  isShowTaxesNote?: boolean | number;
  isImportButton?: number;
}
interface taxesItem {
  beginBalance?: number;
  endBalance?: number;
  taxTactics?: Array<{
    value?: number;
    type?: number;
  }>;
}

interface taxesContent {
  partyA?: string;
  address?: string;
  postCode?: string;
  phone?: string;
  businessLicense?: string;
  principal?: string;
  taxesNote?: string;
}
@Component({
  components: {
    quillEditor,
    Tax,
  },
})
export default class VmCommissionLimit extends Vue {
  $refs: {
    vmCommissionLimitForm: ElForm;
  };

  /**
   * 虚拟店长佣金阈值表单
   * @type {ItemObject}
   */
  public vmCommissionLimitForm: vmCommission = {};
  public isImportButton = 1;

  /**
   * 代理协议服务配置
   * @type {boolean}
   */
  public isOpen = false;

  /**
   * 虚拟店长佣金阈值验证
   * @type {Function}
   */
  public numberRule = (rule, value, callback) => {
    const reg = /^\d*$/;
    if (value === '') {
      callback(new Error('请输入最大佣金比例'));
    } else if (!reg.test(value)) {
      callback(new Error('请输入不小于0的整数'));
    } else if (Number(value) > 100) {
      callback(new Error('请输入不大于100的整数'));
    } else {
      callback();
    }
  };

  /**
   * 验证扣税公式是否输入
   */
  public taxesListRule(rule, value, callback) {
    const reg = /^\d*$/;
    value.forEach((element) => {
      if (element.value == '') {
        callback(new Error('请补全公式'));
      } else if (!reg.test(element.value)) {
        callback(new Error('请输入数字'));
      } else {
        callback();
      }
    });
  }

  /**
   * 虚拟店长佣金阈值表单验证规则
   * @type {ItemObject}
   */
  public vmCommissionLimitFormRules: ItemObject = {
    maxCommission: [{ required: true, message: '不能为空', trigger: 'blur' }],
    serviceRate: [{ required: true, message: '不能为空', trigger: 'blur' }],
  };

  public requireRules = [{ required: true, message: '不能为空', trigger: 'blur' }];

  /**
   * 如果用户输入的是0.00*，自动转化为0
   * @param {string} item
   * @return null
   */
  zeroIntig(item): void {
    if (!this.vmCommissionLimitForm[item] || !(`${this.vmCommissionLimitForm[item]}`).trim()) {
      this.vmCommissionLimitForm[item] = '0';
    }
  }

  /**
   * 富文本配置
   * @type {ItemObject}
   */

  public editorOptionConfig: ItemObject = editorOptionConfig();

  /**
   * 提现税点扣除
   * @return null
   */
  public getVGuiderBaseConfig(): void {
    const self = this;
    IPSService.getVGuiderBaseConfig().then((res: vmCommission) => {
      // 百分比数据 除100
      res.maxCommission = res.maxCommission / 100;
      this.isOpen = Boolean(res.isShowTaxesNote);
      self.vmCommissionLimitForm = res;
    });
  }

  /**
   * 提交更新
   */
  public onSubmitInfo(): void {
    const self = this;
    const resultb = self.vmCommissionLimitForm.taxesList.map((val, i) => {
      return (self.$refs[`taxesList${i}`][0].$refs['taxForm'] as ElForm).validate().then();
    });
    const result = this.$refs.vmCommissionLimitForm.validate();
    resultb.unshift(result);
    Promise.all(resultb)
      .then((res) => {
        if (!res.includes(false)) {
          self.vmCommissionLimitForm.isShowTaxesNote = Number(this.isOpen);
          const postParams = JSON.parse(JSON.stringify(self.vmCommissionLimitForm));
          // 杭俊雅说这里不做校验
          // if(self.isImportButton === 1 && (!self.vmCommissionLimitForm.taxesList || !self.vmCommissionLimitForm.taxesList.length)){
          //     self.$message.warning("请添加固定扣税公式");
          //     return false;
          // }
          // 百分比数据乘 100
          postParams.maxCommission = postParams.maxCommission * 100;
          IPSService.setVGuiderBaseConfig({ postParams }).then((res) => {
            if (res) {
              self.$message.success('保存成功！');
            } else {
              self.$message.success('保存失败！');
            }
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  public deleteTarget(index) {
    this.vmCommissionLimitForm.taxesList.splice(index, 1);
  }

  public addItem() {
    this.vmCommissionLimitForm.taxesList.splice(this.vmCommissionLimitForm.taxesList.length, 0, {
      beginBalance: 0, // 大于等于余额(分)
      endBalance: 0, // 小于等于余额(分)
      taxTactics: [],
    });
  }

  /**
   * 增加扣减项/比例项
   */
  public addCutOrRatioItem(index: number, flag: number) {
    this.vmCommissionLimitForm.taxesList[index].taxTactics.push({
      value: 0,
      type: flag,
    });
  }

  /**
   * 删除扣减项/比例项
   */
  public delCutOrRatioItem(index, targetIndex) {
    this.vmCommissionLimitForm.taxesList[index].taxTactics.splice(targetIndex, 1);
  }

  /* 周期 */

  /**
   * 当组建创建时
   */
  public created() {
    this.getVGuiderBaseConfig();
  }
}
